import { Form, Input } from '~/shared/components/form';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useResetPasswordValidationSchema } from '../lib/useValidationSchema';

import { Container, StyledCTAButton } from '../styled';
import { Fields, LoginInputs } from '../models/fields';
import { TranslationKey } from '~/lib';

type ForgotPasswordSetNewViewProps = {
    handleResetPasswordFromToken: (payload: LoginInputs) => Promise<void>;
    authenticationError: string;
    renderAuthenticationError: (errorMessage: string) => JSX.Element;
    translate: (key: TranslationKey) => string;
};

export const ForgotPasswordSetNewView = ({
    handleResetPasswordFromToken,
    authenticationError,
    renderAuthenticationError,
    translate,
}: ForgotPasswordSetNewViewProps) => {
    const validationSchema = useResetPasswordValidationSchema();
    const methods = useForm<LoginInputs>({
        mode: 'onChange',
        reValidateMode: 'onBlur',
        resolver: yupResolver(validationSchema),
    });
    const { formState, handleSubmit } = methods;

    return (
        <>
            <Form methods={methods} onSubmit={handleSubmit(handleResetPasswordFromToken)}>
                <Container>
                    <h4>{translate('createAccount.changePassword')}</h4>

                    <Input
                        type="password"
                        name={Fields.NewPassword}
                        autoComplete="current-password"
                        placeholder={translate('login.password')}
                        required
                    />

                    <Input
                        type="password"
                        name={Fields.RepeatPassword}
                        autoComplete="current-password"
                        placeholder={translate('createAccount.repeatPassword')}
                        required
                    />

                    <StyledCTAButton type="submit" variant="primary" disabled={!formState.isValid}>
                        {translate('createAccount.changePasswordDK')}
                    </StyledCTAButton>

                    {authenticationError && renderAuthenticationError(authenticationError)}
                </Container>
            </Form>
        </>
    );
};
